import store from "@/store/index";
import router from '@/router/index'
import moment from "moment";
import apiHelper from "@/helpers/apiHelper";

export default {
    verifyAuthRoute(authRouteName) {
        if (!store.getters.authenticated) {
            store.commit("updatePreCasAuthState", {
                routeName: authRouteName,
                time: moment(),
            });
            if (store.getters.visitBookingEnabled) {
                router.push({
                    name: "LoginOptions",
                });
            }
            else {
                apiHelper.casAuth();
            }
        }
    }
}